module.exports = __webpack_public_path__ + "static/img/categories4.45b99eb.png";


//////////////////
// WEBPACK FOOTER
// ./static/recycle/categories4.png
// module id = TgoY
// module chunks = 1